/**
 * Side panel width as a fraction of the viewport (history / chat).
 * Kept in sync with springs in HistoryPanel / Chat and camera `computeInsets`.
 */

export const SIDE_PANEL_VIEWPORT_LG_MIN = 1024;

export const SIDE_PANEL_WIDTH_FRACTION = {
  collapsed: { lg: 0.15, sm: 0.2 },
  expanded: { lg: 0.35, sm: 0.4 },
} as const;

/**
 * CSS length for horizontal inset (padding/margin) so main content stays clear of a side panel.
 */
export function getSidePanelInsetCss(
  isVisible: boolean,
  isExpanded: boolean,
  windowWidth: number,
): string {
  if (!isVisible) return '0px';
  const key = windowWidth >= SIDE_PANEL_VIEWPORT_LG_MIN ? 'lg' : 'sm';
  const frac = isExpanded
    ? SIDE_PANEL_WIDTH_FRACTION.expanded[key]
    : SIDE_PANEL_WIDTH_FRACTION.collapsed[key];
  return `${frac * 100}vw`;
}
